/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AchievementCategory } from './AchievementCategory';
import {
    AchievementCategoryFromJSON,
    AchievementCategoryFromJSONTyped,
    AchievementCategoryToJSON,
    AchievementCategoryToJSONTyped,
} from './AchievementCategory';
import type { AchievementConditionResponse } from './AchievementConditionResponse';
import {
    AchievementConditionResponseFromJSON,
    AchievementConditionResponseFromJSONTyped,
    AchievementConditionResponseToJSON,
    AchievementConditionResponseToJSONTyped,
} from './AchievementConditionResponse';

/**
 * 
 * @export
 * @interface HubAchievementResponse
 */
export interface HubAchievementResponse {
    /**
     * 
     * @type {string}
     * @memberof HubAchievementResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof HubAchievementResponse
     */
    surfaceId: string;
    /**
     * 
     * @type {string}
     * @memberof HubAchievementResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof HubAchievementResponse
     */
    description: string;
    /**
     * HTTPS URL of the badge icon image
     * @type {string}
     * @memberof HubAchievementResponse
     */
    iconUrl?: string | null;
    /**
     * 
     * @type {AchievementCategory}
     * @memberof HubAchievementResponse
     */
    category: AchievementCategory;
    /**
     * 
     * @type {Array<AchievementConditionResponse>}
     * @memberof HubAchievementResponse
     */
    conditions: Array<AchievementConditionResponse>;
    /**
     * Hub Points awarded on unlock
     * @type {number}
     * @memberof HubAchievementResponse
     */
    bonusPoints?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof HubAchievementResponse
     */
    isActive: boolean;
    /**
     * 
     * @type {number}
     * @memberof HubAchievementResponse
     */
    sortOrder: number;
}



/**
 * Check if a given object implements the HubAchievementResponse interface.
 */
export function instanceOfHubAchievementResponse(value: object): value is HubAchievementResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('surfaceId' in value) || value['surfaceId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('category' in value) || value['category'] === undefined) return false;
    if (!('conditions' in value) || value['conditions'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('sortOrder' in value) || value['sortOrder'] === undefined) return false;
    return true;
}

export function HubAchievementResponseFromJSON(json: any): HubAchievementResponse {
    return HubAchievementResponseFromJSONTyped(json, false);
}

export function HubAchievementResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): HubAchievementResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'surfaceId': json['surfaceId'],
        'name': json['name'],
        'description': json['description'],
        'iconUrl': json['iconUrl'] == null ? undefined : json['iconUrl'],
        'category': AchievementCategoryFromJSON(json['category']),
        'conditions': ((json['conditions'] as Array<any>).map(AchievementConditionResponseFromJSON)),
        'bonusPoints': json['bonusPoints'] == null ? undefined : json['bonusPoints'],
        'isActive': json['isActive'],
        'sortOrder': json['sortOrder'],
    };
}

export function HubAchievementResponseToJSON(json: any): HubAchievementResponse {
    return HubAchievementResponseToJSONTyped(json, false);
}

export function HubAchievementResponseToJSONTyped(value?: HubAchievementResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'surfaceId': value['surfaceId'],
        'name': value['name'],
        'description': value['description'],
        'iconUrl': value['iconUrl'],
        'category': AchievementCategoryToJSON(value['category']),
        'conditions': ((value['conditions'] as Array<any>).map(AchievementConditionResponseToJSON)),
        'bonusPoints': value['bonusPoints'],
        'isActive': value['isActive'],
        'sortOrder': value['sortOrder'],
    };
}

